module.exports = __webpack_public_path__ + "static/media/TrueLens-Pattern8.49aeed60.png";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/TrueLens-Pattern8.png
// module id = 223
// module chunks = 8